import { useMutation, useQueryClient } from 'react-query';
import { getSupplierKeys } from './supplierQueries';
import { trpc } from '../../../../lib/trpc';

const useDeleteSupplier = () => {
    const client = useQueryClient();
    return useMutation(
        async ({ id }: { id: number }) => {
            return trpc.SupplierApi.deleteSupplier.query(id);
        },
        {
            onSettled: () => {
                client.invalidateQueries(getSupplierKeys.lists());
            }
        }
    );
};

export default useDeleteSupplier;
